import { render } from "./counter-card.vue?vue&type=template&id=54a70f20&scoped=true"
import script from "./counter-card.vue?vue&type=script&lang=ts"
export * from "./counter-card.vue?vue&type=script&lang=ts"

import "./counter-card.vue?vue&type=style&index=0&id=54a70f20&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54a70f20"

export default script